// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file service/admin/crud/result_category_crud_service_generated.proto (package service, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ResultCategory } from "../../../entity/result_category_pb";

/**
 * IndexResultCategoryArgs メッセージ
 *
 * @generated from message service.IndexResultCategoryArgs
 */
export class IndexResultCategoryArgs extends Message<IndexResultCategoryArgs> {
  /**
   * @generated from field: int32 offset = 1;
   */
  offset = 0;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  constructor(data?: PartialMessage<IndexResultCategoryArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.IndexResultCategoryArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offset", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IndexResultCategoryArgs {
    return new IndexResultCategoryArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IndexResultCategoryArgs {
    return new IndexResultCategoryArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IndexResultCategoryArgs {
    return new IndexResultCategoryArgs().fromJsonString(jsonString, options);
  }

  static equals(a: IndexResultCategoryArgs | PlainMessage<IndexResultCategoryArgs> | undefined, b: IndexResultCategoryArgs | PlainMessage<IndexResultCategoryArgs> | undefined): boolean {
    return proto3.util.equals(IndexResultCategoryArgs, a, b);
  }
}

/**
 * CreateResultCategoryArgs メッセージ
 *
 * @generated from message service.CreateResultCategoryArgs
 */
export class CreateResultCategoryArgs extends Message<CreateResultCategoryArgs> {
  /**
   * @generated from field: repeated entity.ResultCategory result_categorys = 1 [json_name = "result_categorys"];
   */
  resultCategorys: ResultCategory[] = [];

  /**
   * @generated from field: bool force_execute = 2 [json_name = "force_execute"];
   */
  forceExecute = false;

  /**
   * @generated from field: bool skip_version_migration = 3 [json_name = "skip_version_migration"];
   */
  skipVersionMigration = false;

  constructor(data?: PartialMessage<CreateResultCategoryArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateResultCategoryArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "result_categorys", jsonName: "result_categorys", kind: "message", T: ResultCategory, repeated: true },
    { no: 2, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "skip_version_migration", jsonName: "skip_version_migration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateResultCategoryArgs {
    return new CreateResultCategoryArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateResultCategoryArgs {
    return new CreateResultCategoryArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateResultCategoryArgs {
    return new CreateResultCategoryArgs().fromJsonString(jsonString, options);
  }

  static equals(a: CreateResultCategoryArgs | PlainMessage<CreateResultCategoryArgs> | undefined, b: CreateResultCategoryArgs | PlainMessage<CreateResultCategoryArgs> | undefined): boolean {
    return proto3.util.equals(CreateResultCategoryArgs, a, b);
  }
}

/**
 * ReadResultCategoryArgs メッセージ
 *
 * @generated from message service.ReadResultCategoryArgs
 */
export class ReadResultCategoryArgs extends Message<ReadResultCategoryArgs> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  constructor(data?: PartialMessage<ReadResultCategoryArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ReadResultCategoryArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadResultCategoryArgs {
    return new ReadResultCategoryArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadResultCategoryArgs {
    return new ReadResultCategoryArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadResultCategoryArgs {
    return new ReadResultCategoryArgs().fromJsonString(jsonString, options);
  }

  static equals(a: ReadResultCategoryArgs | PlainMessage<ReadResultCategoryArgs> | undefined, b: ReadResultCategoryArgs | PlainMessage<ReadResultCategoryArgs> | undefined): boolean {
    return proto3.util.equals(ReadResultCategoryArgs, a, b);
  }
}

/**
 * UpdateResultCategoryArgs メッセージ
 *
 * @generated from message service.UpdateResultCategoryArgs
 */
export class UpdateResultCategoryArgs extends Message<UpdateResultCategoryArgs> {
  /**
   * @generated from field: repeated entity.ResultCategory result_categorys = 1 [json_name = "result_categorys"];
   */
  resultCategorys: ResultCategory[] = [];

  /**
   * @generated from field: bool allow_missing = 2 [json_name = "allow_missing"];
   */
  allowMissing = false;

  /**
   * @generated from field: bool force_execute = 3 [json_name = "force_execute"];
   */
  forceExecute = false;

  /**
   * @generated from field: bool skip_version_migration = 4 [json_name = "skip_version_migration"];
   */
  skipVersionMigration = false;

  constructor(data?: PartialMessage<UpdateResultCategoryArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateResultCategoryArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "result_categorys", jsonName: "result_categorys", kind: "message", T: ResultCategory, repeated: true },
    { no: 2, name: "allow_missing", jsonName: "allow_missing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "skip_version_migration", jsonName: "skip_version_migration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateResultCategoryArgs {
    return new UpdateResultCategoryArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateResultCategoryArgs {
    return new UpdateResultCategoryArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateResultCategoryArgs {
    return new UpdateResultCategoryArgs().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateResultCategoryArgs | PlainMessage<UpdateResultCategoryArgs> | undefined, b: UpdateResultCategoryArgs | PlainMessage<UpdateResultCategoryArgs> | undefined): boolean {
    return proto3.util.equals(UpdateResultCategoryArgs, a, b);
  }
}

/**
 * DeleteResultCategoryArgs メッセージ
 *
 * @generated from message service.DeleteResultCategoryArgs
 */
export class DeleteResultCategoryArgs extends Message<DeleteResultCategoryArgs> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  /**
   * @generated from field: bool force_execute = 2 [json_name = "force_execute"];
   */
  forceExecute = false;

  constructor(data?: PartialMessage<DeleteResultCategoryArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteResultCategoryArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteResultCategoryArgs {
    return new DeleteResultCategoryArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteResultCategoryArgs {
    return new DeleteResultCategoryArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteResultCategoryArgs {
    return new DeleteResultCategoryArgs().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteResultCategoryArgs | PlainMessage<DeleteResultCategoryArgs> | undefined, b: DeleteResultCategoryArgs | PlainMessage<DeleteResultCategoryArgs> | undefined): boolean {
    return proto3.util.equals(DeleteResultCategoryArgs, a, b);
  }
}

/**
 * IndexResultCategoryReply メッセージ
 *
 * @generated from message service.IndexResultCategoryReply
 */
export class IndexResultCategoryReply extends Message<IndexResultCategoryReply> {
  /**
   * @generated from field: repeated entity.ResultCategory result_categorys = 1 [json_name = "result_categorys"];
   */
  resultCategorys: ResultCategory[] = [];

  constructor(data?: PartialMessage<IndexResultCategoryReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.IndexResultCategoryReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "result_categorys", jsonName: "result_categorys", kind: "message", T: ResultCategory, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IndexResultCategoryReply {
    return new IndexResultCategoryReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IndexResultCategoryReply {
    return new IndexResultCategoryReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IndexResultCategoryReply {
    return new IndexResultCategoryReply().fromJsonString(jsonString, options);
  }

  static equals(a: IndexResultCategoryReply | PlainMessage<IndexResultCategoryReply> | undefined, b: IndexResultCategoryReply | PlainMessage<IndexResultCategoryReply> | undefined): boolean {
    return proto3.util.equals(IndexResultCategoryReply, a, b);
  }
}

/**
 * CreateResultCategoryReply メッセージ
 *
 * @generated from message service.CreateResultCategoryReply
 */
export class CreateResultCategoryReply extends Message<CreateResultCategoryReply> {
  constructor(data?: PartialMessage<CreateResultCategoryReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateResultCategoryReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateResultCategoryReply {
    return new CreateResultCategoryReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateResultCategoryReply {
    return new CreateResultCategoryReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateResultCategoryReply {
    return new CreateResultCategoryReply().fromJsonString(jsonString, options);
  }

  static equals(a: CreateResultCategoryReply | PlainMessage<CreateResultCategoryReply> | undefined, b: CreateResultCategoryReply | PlainMessage<CreateResultCategoryReply> | undefined): boolean {
    return proto3.util.equals(CreateResultCategoryReply, a, b);
  }
}

/**
 * ReadResultCategoryReply メッセージ
 *
 * @generated from message service.ReadResultCategoryReply
 */
export class ReadResultCategoryReply extends Message<ReadResultCategoryReply> {
  /**
   * @generated from field: repeated entity.ResultCategory result_categorys = 1 [json_name = "result_categorys"];
   */
  resultCategorys: ResultCategory[] = [];

  constructor(data?: PartialMessage<ReadResultCategoryReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ReadResultCategoryReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "result_categorys", jsonName: "result_categorys", kind: "message", T: ResultCategory, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadResultCategoryReply {
    return new ReadResultCategoryReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadResultCategoryReply {
    return new ReadResultCategoryReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadResultCategoryReply {
    return new ReadResultCategoryReply().fromJsonString(jsonString, options);
  }

  static equals(a: ReadResultCategoryReply | PlainMessage<ReadResultCategoryReply> | undefined, b: ReadResultCategoryReply | PlainMessage<ReadResultCategoryReply> | undefined): boolean {
    return proto3.util.equals(ReadResultCategoryReply, a, b);
  }
}

/**
 * UpdateResultCategoryReply メッセージ
 *
 * @generated from message service.UpdateResultCategoryReply
 */
export class UpdateResultCategoryReply extends Message<UpdateResultCategoryReply> {
  constructor(data?: PartialMessage<UpdateResultCategoryReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateResultCategoryReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateResultCategoryReply {
    return new UpdateResultCategoryReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateResultCategoryReply {
    return new UpdateResultCategoryReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateResultCategoryReply {
    return new UpdateResultCategoryReply().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateResultCategoryReply | PlainMessage<UpdateResultCategoryReply> | undefined, b: UpdateResultCategoryReply | PlainMessage<UpdateResultCategoryReply> | undefined): boolean {
    return proto3.util.equals(UpdateResultCategoryReply, a, b);
  }
}

/**
 * DeleteResultCategoryReply メッセージ
 *
 * @generated from message service.DeleteResultCategoryReply
 */
export class DeleteResultCategoryReply extends Message<DeleteResultCategoryReply> {
  constructor(data?: PartialMessage<DeleteResultCategoryReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteResultCategoryReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteResultCategoryReply {
    return new DeleteResultCategoryReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteResultCategoryReply {
    return new DeleteResultCategoryReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteResultCategoryReply {
    return new DeleteResultCategoryReply().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteResultCategoryReply | PlainMessage<DeleteResultCategoryReply> | undefined, b: DeleteResultCategoryReply | PlainMessage<DeleteResultCategoryReply> | undefined): boolean {
    return proto3.util.equals(DeleteResultCategoryReply, a, b);
  }
}

